import { formatDate } from "services";
import { DateTime } from "enums";
import { filterRequest } from "./common.mapper";

export const resourceType = {
  name: {
    key: "name",
  },
  id: {
    key: "resourceTypeId",
  },
  defaultCapacity: {
    key: "defaultCapacity",
  },
  defaultCleanupDuration: {
    key: "defaultCleanupDuration",
  },
  shape: {
    key: "shape",
  },
  defaultReservationDuration: {
    key: "defaultReservationDuration",
  },
  minimumSpentAmount: {
    key: "minimumSpentAmount",
  },
  isActive: {
    key: "isActive",
  },
};

export const resourceTypeListResponse = {
  resourceTypeId: {
    key: "id",
  },
  name: {
    key: "name",
  },
  defaultCapacity: {
    key: "defaultCapacity",
  },
  defaultCleanupDuration: {
    key: "defaultCleanupDuration",
  },
  shape: {
    key: "shape",
  },
  defaultReservationDuration: {
    key: "defaultReservationDuration",
  },
  minimumSpentAmount: {
    key: "minimumSpentAmount",
  },
  isActive: {
    key: "isActive",
  },
  createdDate: {
    transform: ({ src }) => {
      return formatDate(src.createdDate, DateTime.C) ?? "-";
    },
  },
};

export const resourceTypeDetailResponse = {
  resourceTypeId: {
    key: "id",
  },
  name: {
    key: "name",
  },
  defaultCapacity: {
    key: "defaultCapacity",
  },
  defaultCleanupDuration: {
    key: "defaultCleanupDuration",
  },
  shape: {
    key: "shape",
  },
  defaultReservationDuration: {
    key: "defaultReservationDuration",
  },
  minimumSpentAmount: {
    key: "minimumSpentAmount",
  },
  isActive: {
    key: "isActive",
  },
};

export const resourceTypeListFilterRequest = {
  ...filterRequest,
  venueId: { key: "venueId" },
  page: { key: "page" },
  pageSize: { key: "pageSize" },
  searchKey: { key: "searchKey" },
};

export const resourceTypeRequest = {
  name: { key: "name" },
  defaultCapacity: { key: "defaultCapacity" },
  defaultCleanupDuration: { key: "defaultCleanupDuration" },
  shape: { key: "shape" },
  defaultReservationDuration: { key: "defaultReservationDuration" },
  minimumSpentAmount: { key: "minimumSpentAmount" },
  isActive: { key: "isActive" },
  venueId: { key: "venueId" },
  resourceTypeId: { key: "id" },
};
